export default completed => [
  '/accountsettings',
  `/contacts`,
  '/contactgroups',
  `/forms${completed[3] ? '' : '/new'}`,
  `/tasks${completed[4] ? '' : '/new'}`,
]
